import script from "./UserArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./UserArticle.vue?vue&type=script&setup=true&lang=js"

import "./UserArticle.vue?vue&type=style&index=0&id=7a2d1f63&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2d1f63"]])

export default __exports__